import {
  formatLabCalendarDate,
  formatLabClockTime24,
} from "../../utils/labTime";

export function formatDate(dateValue: string | null): string {
  if (!dateValue) return "—";
  return formatLabCalendarDate(dateValue);
}

export function formatDateTime(dateValue: string | null): string {
  if (!dateValue) return "—";
  return `${formatLabCalendarDate(dateValue)} ${formatLabClockTime24(
    dateValue
  )}`;
}
